class TabSwitching extends HTMLElement {
    constructor() {
      super();
        this.headers = this.querySelectorAll(".article-with-tabs__container")
        this.headers.forEach((header) => {
          header.addEventListener('click',(event)=>{
            this.onChange(header)
          })
        });
    }

    connectedCallback() {
      this.initializeSlide();
    }

    initializeSlide() {
      if (typeof Splide === 'undefined') return;

      this.fetaturedCollectionEle = this.querySelector('.featured-collection__slide')
      if (this.fetaturedCollectionEle) {
        this.fetaturedCollectionEle.querySelectorAll('.tabs-splide__container').forEach((each)=> {
          this.slider = new Splide(each, {
            type: 'slide',
            perPage: 6,
            perMove: 1,
            focus: 'left',
            pagination: false,
            arrows: false,
            gap: '17px',
            noDrag: '.no-drag',
            breakpoints: {
              750: {
                perPage: 2,
                perMove: 1,
                gap: '10px'
              },
            }
          });
          this.slider.mount();
        })
      } else {
        this.querySelectorAll('.tabs-splide__container').forEach((each)=> {
          this.slider = new Splide(each, {
            type: 'slide',
            perPage: 6,
            perMove: 1,
            focus: 'left',
            pagination: false,
            arrows: true,
            gap: '17px',
            noDrag: '.no-drag',
            breakpoints: {
              750: {
                perPage: 2,
                gap: '10px'
              },
            }
          });
          this.slider.mount();
        })
      }
    }
  
    onChange(target){
      const currentTabId = target.dataset.tab;
      this.headers.forEach(header => {
        header.classList.remove('article-tab-active')
      });
      target.classList.add('article-tab-active')
  
      this.initializeSlide();
  
      this.querySelectorAll('[data-content-id]')?.forEach((tab) => {
        if(tab.dataset.contentId == currentTabId){
          tab.classList.add('article-content-active')
        }else{
          tab.classList.remove('article-content-active')
        }
      });
    }
  }
  customElements.define("tab-switch", TabSwitching);